<form [formGroup]="customScreenForm" *ngIf="formChanges$ | async">
    <p class="step-help-text">
        Creating a custom screen allows you to quickly add contact info, your logo and a tagline to be downloaded for the panel.
    </p>
    <section>
        <p>
            <mat-form-field appearance="outline" *letVar="fields.tag1Line as field" floatLabel="always">
                <mat-label i18n>Tag Line 1</mat-label>
                <input
                    matInput
                    id="tag1Line"
                    type="text"
                    formControlName="tag1Line"
                    required
                    [errorStateMatcher]="errorMatcher"
                    maxlength="89"
                    placeholder="Enter dealer tag line"
                />
                <mat-hint i18n><span class="step-help-text input-help">Max 90 characters</span></mat-hint>
                <mat-error>
                    <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                </mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" *letVar="fields.tag2Line as field" floatLabel="always">
                <mat-label i18n>Tag Line 2</mat-label>
                <input
                    matInput
                    id="tag2Line"
                    type="text"
                    formControlName="tag2Line"
                    required
                    [errorStateMatcher]="errorMatcher"
                    maxlength="31"
                    placeholder="Enter dealer tag line"
                />
                <mat-hint i18n><span class="step-help-text input-help">Max 30 characters</span></mat-hint>
                <mat-error>
                    <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                </mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" *letVar="fields.contactLine1 as field" floatLabel="always">
                <mat-label i18n>Contact Line 1</mat-label>
                <input
                    matInput
                    id="contactLine1"
                    type="text"
                    placeholder="Enter dealer phone number, email, or website"
                    formControlName="contactLine1"
                    [errorStateMatcher]="errorMatcher"
                    maxlength="60"
                />
                <mat-hint i18n><span class="step-help-text input-help">Max 60 characters</span></mat-hint>
                <mat-error>
                    <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                </mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" *letVar="fields.contactLine2 as field" floatLabel="always">
                <mat-label i18n>Contact Line 2 (Optional)</mat-label>
                <input
                    matInput
                    id="contactLine2"
                    type="text"
                    placeholder="Enter dealer phone number, email, or website"
                    formControlName="contactLine2"
                    [errorStateMatcher]="errorMatcher"
                    maxlength="60"
                />
                <mat-hint i18n><span class="step-help-text input-help">Max 60 characters</span></mat-hint>
                <mat-error>
                    <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                </mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" *letVar="fields.contactLine3 as field" floatLabel="always">
                <mat-label i18n>Contact Line 3 (Optional)</mat-label>
                <input
                    matInput
                    id="contactLine3"
                    type="text"
                    placeholder="Enter dealer phone number, email, or website"
                    formControlName="contactLine3"
                    [errorStateMatcher]="errorMatcher"
                    maxlength="35"
                />
                <mat-hint i18n><span class="step-help-text input-help">Max 35 characters</span></mat-hint>
                <mat-error>
                    <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                </mat-error>
            </mat-form-field>
        </p>
    </section>

    <section>
        <div class="upload-logo-btn-container">
            <button mat-stroked-button color="primary" (click)="uploadLogo()" type="button" i18n>Upload Logo</button>

            <div class="logoHint">
                <mat-icon svgIcon="exclamation"></mat-icon>
                <p i18n>Logo must have .png or .jpg format</p>
            </div>
        </div>
        <div *ngIf="logoName" class="reset-logo-container">
            <a mat-button color="warn" (click)="resetLogo()"> x</a>
            <p class="del-upload">
                {{ logoName }}
            </p>
        </div>
    </section>

    <section>
        <div class="previewScreen">
            <button mat-stroked-button [disabled]="this.customScreenForm.invalid" (click)="openPreviewCustomScreen()" type="button" i18n>
                Preview Screen
            </button>
        </div>
    </section>
</form>

<ng-template #previewImage>
    <div class="hidden">
        <app-preview-custom-screen
            [customScreenForm]="formChanges$ | async"
            (emitSvgChanges)="onSvgChanges($event)"
        ></app-preview-custom-screen>
    </div>
    <div *ngIf="imageUrl$ | async as imageUrl" class="preview-image-container">
        <div class="header-container">
            <h2>Preview</h2>
            <button class="mat-button icon-button close" aria-label="close dialog" [mat-dialog-close]="">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="content-container">
            <img [src]="imageUrl" width="100%" alt="preview" />
        </div>
    </div>
</ng-template>
